@if (globalSearchContext(); as context) {
  @if (toastPhase() !== 'hidden') {
    <section
      class="page-help-toast"
      [class.page-help-toast--settling]="toastPhase() === 'settling'"
      role="status"
      aria-live="polite"
    >
      <span class="page-help-toast__beam" aria-hidden="true"></span>
      <div class="page-help-toast__icon" aria-hidden="true">
        <i class="fas fa-location-dot"></i>
      </div>

      <div class="page-help-toast__content">
        @if (context.searchedText) {
          <span class="page-help-toast__eyebrow">
            {{ 'pageHelp.globalSearch.searched' | transloco: { query: context.searchedText } }}
          </span>
        }
        <div class="page-help-toast__title">
          <strong>{{ context.label }}</strong>
          @if (context.section) {
            <span>{{ context.section }}</span>
          }
        </div>
        <p>{{ context.description }}</p>
        @if (context.navigationPath.length > 0) {
          <div class="page-help-toast__path">{{ pathText(context.navigationPath) }}</div>
        }
      </div>

      <button
        type="button"
        class="page-help-toast__close"
        [attr.aria-label]="'pageHelp.closeToast' | transloco"
        (click)="dismissToast()"
      >
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </section>
  }
}

@if (panelOpen()) {
  <button
    type="button"
    class="page-help-backdrop"
    [attr.aria-label]="'pageHelp.close' | transloco"
    (click)="closePanel()"
  ></button>
  <aside class="page-help-panel" aria-labelledby="pageHelpTitle">
    <header class="page-help-panel__header">
      <div>
        <span>{{ 'pageHelp.eyebrow' | transloco }}</span>
        <h2 id="pageHelpTitle">{{ insightKey('title') | transloco }}</h2>
      </div>
      <button type="button" [attr.aria-label]="'pageHelp.close' | transloco" (click)="closePanel()">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </header>

    <div class="page-help-panel__body">
      <section class="page-help-panel__section">
        <h3>{{ 'pageHelp.sections.purpose' | transloco }}</h3>
        <p>{{ insightKey('summary') | transloco }}</p>
      </section>

      <section class="page-help-panel__section">
        <h3>{{ 'pageHelp.sections.actions' | transloco }}</h3>
        <ul>
          @for (action of insightKey('actions') | transloco; track action) {
            <li>{{ action }}</li>
          }
        </ul>
      </section>

      @if (globalSearchContext(); as context) {
        <section class="page-help-panel__section page-help-panel__section--search">
          <h3>{{ 'pageHelp.globalSearch.title' | transloco }}</h3>
          @if (context.searchedText) {
            <div class="page-help-panel__search-term">
              {{ 'pageHelp.globalSearch.searched' | transloco: { query: context.searchedText } }}
            </div>
          }
          <strong>{{ context.label }}</strong>
          <p>{{ context.description }}</p>
          @if (context.navigationPath.length > 0) {
            <div class="page-help-panel__path">{{ pathText(context.navigationPath) }}</div>
          }
          @if (context.actionHint) {
            <div class="page-help-panel__hint">{{ context.actionHint }}</div>
          }
        </section>
      }
    </div>
  </aside>
}

<button
  type="button"
  class="page-help-badge"
  [class.page-help-badge--active]="hasGlobalSearchContext()"
  [class.page-help-badge--receiving]="toastPhase() === 'settling'"
  [class.page-help-badge--scroll-visible]="scrollToTopVisible()"
  [attr.aria-expanded]="panelOpen()"
  [attr.aria-label]="'pageHelp.open' | transloco"
  (click)="togglePanel()"
>
  <i class="fas fa-info" aria-hidden="true"></i>
  @if (hasGlobalSearchContext()) {
    <span aria-hidden="true"></span>
  }
</button>
